/* ============================================================
   Mini-cart popover — desktop hover peek under #cart-icon-bubble.
   - Desktop + fine pointer only; mobile/touch stays inert (tap → drawer).
   - Does NOT touch the #cart-icon-bubble <a> (cart-drawer.js owns its click).
   - Refreshes [data-cart-mini-body] on cartUpdate via the Section Rendering API.
   ============================================================ */
(function () {
  'use strict';
  if (window.__cartMiniLoaded) return;
  window.__cartMiniLoaded = true;

  var DESKTOP = window.matchMedia('(min-width: 990px) and (pointer: fine)');
  var hideTimer = null;

  function pop() { return document.querySelector('[data-cart-mini-pop]'); }
  function hasItems() {
    var b = document.querySelector('[data-cart-mini-body]');
    return !!(b && b.querySelector('.cart-mini__item'));
  }
  function show() {
    var p = pop();
    if (!DESKTOP.matches || !p || !hasItems()) return;
    clearTimeout(hideTimer);
    p.classList.add('cart-mini__pop--open');
    p.setAttribute('aria-hidden', 'false');
  }
  function hide() {
    var p = pop();
    if (!p) return;
    p.classList.remove('cart-mini__pop--open');
    p.setAttribute('aria-hidden', 'true');
  }
  function hideSoon() { clearTimeout(hideTimer); hideTimer = setTimeout(hide, 200); }

  function bind() {
    var w = document.querySelector('[data-cart-mini]');
    if (!w || w.dataset.miniBound) return;
    w.dataset.miniBound = '1';
    w.addEventListener('mouseenter', show);
    w.addEventListener('mouseleave', hideSoon);
    w.addEventListener('focusin', show);
    w.addEventListener('focusout', hideSoon);
  }

  // "לעגלה המלאה" → open the full drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-mini-open]')) {
      e.preventDefault();
      hide();
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function') cd.open();
    }
  });

  // refresh popover contents when the cart changes (reuses the Liquid markup)
  async function refresh() {
    try {
      var data = await (await fetch(location.pathname + '?sections=header', { headers: { 'Accept': 'application/json' } })).json();
      if (!data.header) return;
      var doc = new DOMParser().parseFromString(data.header, 'text/html');
      var fresh = doc.querySelector('[data-cart-mini-body]');
      var cur = document.querySelector('[data-cart-mini-body]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      if (!hasItems()) hide();
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);

  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('theme:cart:update', refresh);
})();
